
import { HeroSection } from "@/components/bars-and-clubs/HeroSection";
import { FeaturesSection } from "@/components/bars-and-clubs/FeaturesSection";
import { CoreFeaturesSection } from "@/components/bars-and-clubs/CoreFeaturesSection";
import { ComingSoonSection } from "@/components/bars-and-clubs/ComingSoonSection";
import { CTASection } from "@/components/bars-and-clubs/CTASection";

const BarsAndClubs = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-black via-gray-900 to-gray-800">
      <HeroSection />
      <FeaturesSection />
      <CoreFeaturesSection />
      <ComingSoonSection />
      <CTASection />
    </div>
  );
};

export default BarsAndClubs;
